import { Card } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Crown, MessageCircle } from "lucide-react";

export const DemoMeganWelcome = () => {
  return (
    <Card className="p-5 bg-card/95 backdrop-blur-sm border-border/50">
      <div className="space-y-4">
        {/* Header */}
        <div className="flex items-center gap-2 justify-center text-primary">
          <MessageCircle className="w-4 h-4" />
          <span className="text-sm font-medium">You have a message!</span>
        </div>
        
        {/* Message bubble */}
        <div className="bg-muted/50 rounded-2xl p-4 space-y-3">
          {/* Sender info */}
          <div className="flex items-center gap-3">
            <div className="relative">
              <Avatar className="h-12 w-12 border-2 border-primary">
                <AvatarImage src="/logo/wellness-logo.png" alt="Megan" />
                <AvatarFallback className="bg-primary text-primary-foreground">M</AvatarFallback>
              </Avatar>
              {/* Premium hat indicator */}
              <div className="absolute -top-1 -right-1 w-5 h-5 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center">
                <Crown className="w-3 h-3 text-amber-950" />
              </div>
            </div>
            <div>
              <div className="flex items-center gap-1.5">
                <p className="font-semibold text-foreground">Megan</p>
                <span className="text-xs bg-primary/20 text-primary px-1.5 py-0.5 rounded-full">Founder</span>
              </div>
              <p className="text-xs text-muted-foreground">The Wellness Cowgirl</p>
            </div>
          </div>
          
          {/* Message content */}
          <div className="bg-background/80 rounded-xl p-3 text-sm text-foreground leading-relaxed">
            <p>Hey! I'm Megan, the Wellness Cowgirl. Welcome to the herd! 🤠</p>
            <p className="mt-2">
              I'm so glad you're here. Feel free to reach out anytime - I'm here to help you on your wellness journey!
            </p>
            <p className="mt-2 text-primary font-medium">
              See you at an event soon! 💕
            </p>
          </div>
          
          {/* Timestamp */}
          <p className="text-xs text-muted-foreground text-right">Just now</p>
        </div>
        
        {/* Note */}
        <p className="text-center text-xs text-muted-foreground">
          Megan is now your first friend - message her anytime!
        </p>
      </div>
    </Card>
  );
};
